import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { withRights } from '../../../../providers/RightsConsumer';
import { TableContainer, Table, TableBody, TableCell, TableRow, Grid } from '@mui/material';
import { Button } from '@totalsoft/rocket-ui';
import { Prompt } from 'react-router-dom';
import OfferDecisionConditionRowComponent from './OfferDecisionConditionRowComponent';
import { BoldTableHead, GridActionsWrapper } from 'components/common/CommonStyles';

const OfferDecisionConditionListComponent = ({
  onAdd,
  onSave,
  onRemoveItem,
  onPropertyChange,
  selectedConditions,
  remainingConditions,
  disableAddButton,
  saving,
  t,
  rights
}) => {
  return (
    <Grid container spacing={1}>
      <Prompt when={selectedConditions.some(x => x.dirtyInfo.isDirty)} message={() => t('LeavingWithoutSaving')} />
      <TableContainer>
        <Table>
          <BoldTableHead>
            <TableRow>
              <TableCell>{t('OfferEdit.Decision.Condition.ComposedCode')}</TableCell>
              <TableCell>{t('OfferEdit.Decision.Condition.User')}</TableCell>
              <TableCell>{t('OfferEdit.Decision.Condition.Comment')}</TableCell>
              <TableCell></TableCell>
            </TableRow>
          </BoldTableHead>
          <TableBody>
            {selectedConditions.map(({ document, validationInfo }, idx) => {
              return (
                <OfferDecisionConditionRowComponent
                  key={idx}
                  condition={document}
                  remainingConditions={remainingConditions}
                  validationInfo={validationInfo || {}}
                  onRemoveItem={onRemoveItem(idx)}
                  onPropertyChange={onPropertyChange(idx)}
                />
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      {!rights.isImage && (
        <GridActionsWrapper item mt={2}>
          <Button color='primary' onClick={onAdd} disabled={rights.readOnlyFull || disableAddButton || !rights.decisionConditionsWrite}>
            {t('Add')}
          </Button>
          <Button
            color='primary'
            onClick={onSave}
            disabled={
              rights.readOnlyFull || saving || !selectedConditions.every(x => x.validationInfo.isValid) || !rights.decisionConditionsWrite
            }
          >
            {saving ? t('Saving') : t('Save')}
          </Button>
        </GridActionsWrapper>
      )}
    </Grid>
  );
};

OfferDecisionConditionListComponent.propTypes = {
  onAdd: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onRemoveItem: PropTypes.func.isRequired,
  onPropertyChange: PropTypes.func.isRequired,
  selectedConditions: PropTypes.array.isRequired,
  remainingConditions: PropTypes.array.isRequired,
  disableAddButton: PropTypes.bool.isRequired,
  saving: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
  rights: PropTypes.object.isRequired
};

export default withTranslation()(withRights(OfferDecisionConditionListComponent));
